// Animate header banner closing
const closeBtn = document.querySelector('.header-banner__close-button');

const closeBanner = () => {
  const banner = document.querySelector('.header-banner');
  banner.classList.add('header-banner--transition');

  const transitionEndHandler = () => {
    banner.classList.add('header-banner--hidden');
    banner.classList.remove('header-banner--transition');
    banner.removeEventListener('transitionend', transitionEndHandler);
  };

  banner.addEventListener('transitionend', transitionEndHandler);
};

closeBtn.addEventListener('click', closeBanner);

// Update CTA button text size on mobile
const isDesktop = window.matchMedia('(min-width: 768px)').matches;
if (!isDesktop) {
  const ctaBtn = document.querySelector('.header-banner__cta-button');
  ctaBtn.classList.add('a-heading__7');
}

// Lapin Kansa, Ilkka-Pohjalainen and Komiat use white text with header-banner--brand-color-2 background
const isBrandColor2 = !!document.querySelector('.header-banner--brand-color-2');
const LAPIN_KANSA = 'lapinkansafi';
const ILKKA_POHJALAINEN = 'ilkkapohjalainenfi';
const KOMIAT = 'komiatfi';
const channelSlug = window.digitalData.channel.slug;

if ((channelSlug === LAPIN_KANSA || channelSlug === ILKKA_POHJALAINEN || channelSlug === KOMIAT) && isBrandColor2) {
  document.querySelector('.header-banner').classList.add('header-banner--inverted-colors');
}
